import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui';

const SessionExpiredBanner = () => {
  const { user, logout } = useAuth();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleUnauthorized = () => {
      if (user) {
        setVisible(true);
      }
    };

    window.addEventListener('auth:unauthorized', handleUnauthorized);
    return () => window.removeEventListener('auth:unauthorized', handleUnauthorized);
  }, [user]);

  if (!user || !visible) {
    return null;
  }

  const handleLogout = () => {
    logout();
    window.location.href = '/login';
  };

  return (
    <div className="fixed top-4 left-1/2 z-50 w-full max-w-3xl -translate-x-1/2 rounded-soft-lg border border-amber-200 bg-amber-50 px-4 py-3 shadow-soft">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="text-sm font-semibold text-amber-900">Session needs attention</p>
          <p className="text-sm text-amber-800">
            Your session may have expired. Please log in again to continue.
          </p>
        </div>
        <div className="flex gap-2">
          <Button variant="ghost" size="sm" onClick={() => setVisible(false)}>
            Dismiss
          </Button>
          <Button variant="primary" size="sm" onClick={handleLogout}>
            Log in
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SessionExpiredBanner;
